import { ref } from 'vue';

export const UI_SETTINGS_SCHEMA = {
  show_all_tab: Boolean,
};

export function useCustomSettingsValidation(initialSettings = {}) {
  const sanitizeCustomSettings = (settings = {}) => {
    const sanitized = {};

    Object.keys(UI_SETTINGS_SCHEMA).forEach(key => {
      if (Object.hasOwn(settings, key)) {
        switch (UI_SETTINGS_SCHEMA[key]) {
          case Boolean:
            sanitized[key] = Boolean(settings[key]);
            break;
          case Number:
            sanitized[key] = Number(settings[key]);
            break;
          case String:
            sanitized[key] = String(settings[key]);
            break;
          default:
            sanitized[key] = settings[key];
        }
      }
    });

    return sanitized;
  };

  const customSettings = ref(sanitizeCustomSettings(initialSettings));

  const validateCustomSettings = value => {
    const allowedKeys = Object.keys(UI_SETTINGS_SCHEMA);

    const hasOnlyAllowedKeys = Object.keys(value).every(key =>
      allowedKeys.includes(key)
    );

    const hasCorrectTypes = Object.entries(value).every(([key, val]) => {
      if (!allowedKeys.includes(key)) return true;
      const expectedType = UI_SETTINGS_SCHEMA[key];

      switch (expectedType) {
        case Boolean:
          return typeof val === 'boolean';
        case Number:
          return typeof val === 'number';
        case String:
          return typeof val === 'string';
        default:
          return true;
      }
    });

    return hasOnlyAllowedKeys && hasCorrectTypes;
  };

  return {
    customSettings,
    validateCustomSettings,
    sanitizeCustomSettings,
  };
}
